.filestack-button {
    &:disabled {
        pointer-events: none;
        opacity: 0.5;
    }
}
